import { Trophy, Landmark, Gavel } from "lucide-react";

const practiceAreas = [
{
  icon: Trophy,
  title: "Sports Law",
  description:
  "India's emerging sports industry demands specialist legal expertise. LexSant advises athletes, agents, clubs, federations, and sports brands on contracts, disputes, regulatory compliance, image rights, and governance.",
  clients: "Athletes · Agents · Sports Franchises · Federations · Sports Brands",
  tags: ["Athlete Representation", "Sports Governance", "Sponsorship Structuring", "Dispute Resolution"]
},
{
  icon: Landmark,
  title: "Taxation Advisory & Litigation",
  description: "From proactive tax structuring to high stakes tax litigation, LexSant delivers end to end support. We bridge the gap between tax advisory and the courtroom so you never have to switch firms mid crisis.",

  clients: "Businesses · HNIs · Corporates · Family Offices",
  tags: ["Tax Planning", "Tax Disputes", "Appellate Tribunal", "Advisory & Structuring"]
},
{
  icon: Gavel,
  title: "Criminal & Civil Litigation",
  description: "When it matters most, you need partners in the courtroom not associates. LexSant handles complex criminal defence, civil disputes, and commercial litigation with the gravitas your case demands.",

  clients: "Individuals · Corporates · Promoters · Institutions",
  tags: ["Criminal Defence", "Civil Litigation", "Regulatory Proceedings", "Arbitration"]
}];


const PracticeCard = ({ area, index }) => (
  <div
    data-testid={`practice-area-card-${index}`}
    className="animate-on-scroll group border border-gold/20 bg-navy-dark p-8 md:p-10 hover:border-gold/60 transition-all duration-500 relative overflow-hidden">

    <div className="absolute top-0 left-0 w-full h-px bg-gold/0 group-hover:bg-gold/40 transition-all duration-500" />

    <area.icon className="w-8 h-8 text-gold mb-6" />

    <h3 className="font-heading text-2xl md:text-3xl text-white tracking-tight mb-4">
      {area.title}
    </h3>

    <p className="text-sm md:text-base text-gray-400 font-body leading-relaxed mb-6">
      {area.description}
    </p>

    <div className="flex flex-wrap gap-2 mb-6">
      {area.tags.map((tag) =>
        <span
          key={tag}
          className="text-xs font-body tracking-wide text-gold/80 border border-gold/20 px-3 py-1">
          {tag}
        </span>
      )}
    </div>

    <div className="pt-4 border-t border-gold/10">
      <p className="text-xs tracking-widest uppercase text-gold/50 font-body mb-1">
        Who we work with
      </p>
      <p className="text-sm text-gray-400 font-body">{area.clients}</p>
    </div>
  </div>
);

export default function PracticeAreas() {
  return (
    <section id="practice" data-testid="practice-areas-section" className="py-24 md:py-32 bg-navy-base">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-16 animate-on-scroll">
          <p className="text-sm tracking-[0.3em] uppercase text-gold font-body font-medium mb-4">
            Practice Areas
          </p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tight text-white">
            Specialized expertise across <br className="hidden md:block" />
            three disciplines.
          </h2>
          <div className="h-px w-16 bg-gold/40 mt-6" />
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {practiceAreas.map((area, i) =>
            <PracticeCard key={area.title} area={area} index={i} />
          )}
        </div>
      </div>
    </section>);

}